import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useParams, useNavigate, useLocation } from 'react-router-dom';
import PlanningHome from './components/PlanningHome';
import PlanGroupSchedule from './components/PlanGroupSchedule';
import PlanPlaceDetail from './components/PlanPlaceDetail';

import './App.css';
import './ConneoPlancard.css';
import './UnauthenticatedMessage.css'; 

function PlanningApp() {
  const { conneoId, groupId, placeId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState(null);
  
  // Extract token from URL query parameters
  const searchParams = new URLSearchParams(location.search);

  // Bepaal de huidige view op basis van URL
  useEffect(() => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    
    // Log voor debugging
    console.log('URL veranderd:', location.pathname);
    console.log('Path parts:', pathParts);
    
    // Controleer of groupId en placeId in de URL aanwezig zijn
    const urlGroupId = pathParts.length >= 3 && pathParts[1] === 'group' ? pathParts[2] : null;
    const urlPlaceId = pathParts.length >= 5 && pathParts[3] === 'place' ? pathParts[4] : null;
    
    console.log('URL Group ID:', urlGroupId);
    console.log('URL Place ID:', urlPlaceId);
    
    // Laad data op basis van URL indien nodig
    const loadData = async () => {
      if (urlGroupId && !selectedGroup) {
        // Hier zou je de groep moeten ophalen op basis van ID
        // Dit is een voorbeeld - je moet dit aanpassen met echte API-calls
        console.log('Groepsdata laden voor ID:', urlGroupId);
        // setSelectedGroup(await fetchGroup(urlGroupId));
      }
      
      if (urlPlaceId && !selectedPlace) {
        // Hier zou je de planplaats moeten ophalen op basis van ID
        // Dit is een voorbeeld - je moet dit aanpassen met echte API-calls
        console.log('Planplaatsdata laden voor ID:', urlPlaceId);
        // setSelectedPlace(await fetchPlace(urlPlaceId));
      }
    };
    
    loadData();
  }, [location, conneoId, groupId, placeId, selectedGroup, selectedPlace]);

  // Handler om naar groepen te gaan
  const handleBackToGroups = () => {
    const token = searchParams.get('token');
    navigate(`/${conneoId}${token ? `?token=${token}` : ''}`);
    setSelectedGroup(null);
    setSelectedPlace(null);
  };

  // Handler om naar een specifieke groep te gaan
  const handleSelectGroup = (group) => {
    const token = searchParams.get('token');
    navigate(`/${conneoId}/group/${group.objectid}${token ? `?token=${token}` : ''}`);
    setSelectedGroup(group);
    setSelectedPlace(null);
  };

  // Handler om naar een specifieke planplaats te gaan
  const handleSelectPlace = (place) => {
    const token = searchParams.get('token');
    navigate(`/${conneoId}/group/${selectedGroup.objectid}/place/${place.planPlaceId}${token ? `?token=${token}` : ''}`);
    setSelectedPlace(place);
  };

  // Handler om terug te gaan naar planplaatsen
  const handleBackToPlaces = () => {
    const token = searchParams.get('token');
    navigate(`/${conneoId}/group/${selectedGroup.objectid}${token ? `?token=${token}` : ''}`);
    setSelectedPlace(null);
  };

  // Render op basis van URL path
  const renderContent = () => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    
    // Alleen conneoId - Groups view
    if (pathParts.length === 1) {
      return (
        <PlanningHome 
          conneoId={conneoId} 
          onSelectGroup={handleSelectGroup} 
        />
      );
    }
    
    // conneoId/group/:groupId - Places view
    if (pathParts.length === 3 && pathParts[1] === 'group' && selectedGroup) {
      return (
        <PlanGroupSchedule 
          conneoId={conneoId}
          group={selectedGroup}
          onBack={handleBackToGroups}
          onSelectPlace={handleSelectPlace}
        />
      );
    }
    
    // conneoId/group/:groupId/place/:placeId - Place detail view
    if (pathParts.length === 5 && pathParts[1] === 'group' && pathParts[3] === 'place' && selectedPlace) {
      return (
        <PlanPlaceDetail 
          conneoId={conneoId}
          place={selectedPlace}
          onBack={handleBackToPlaces}
        />
      );
    }
    
    // Fallback - Groups view
    return (
      <PlanningHome 
        conneoId={conneoId} 
        onSelectGroup={handleSelectGroup} 
      />
    );
  };

  // Render de juiste view
  if (!conneoId) {
    return <UnauthenticatedMessage />;
  }

  return renderContent();
}

function UnauthenticatedMessage() {
  document.title = `Conneo Planning`;
  return (
    <div className="unauthenticated-container">
      <div className="unauthenticated-icon">🔒</div>
      <h2 className="unauthenticated-title">Access Denied</h2>
      <p className="unauthenticated-text">
        Je bent niet geauthenticeerd om deze pagina te bekijken. Geef een geldig <strong>Conneo ID</strong> op in de URL.
      </p>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h4>Conneo Planning</h4>
        </header>
        <Routes>
          <Route path="/" element={<UnauthenticatedMessage />} />
          <Route path="/:conneoId" element={<PlanningApp />} />
          <Route path="/:conneoId/group/:groupId" element={<PlanningApp />} />
          <Route path="/:conneoId/group/:groupId/place/:placeId" element={<PlanningApp />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;